export default __webpack_public_path__ + "static/media/navFrameTop.c8226e8d.png";